import {ODDS_TYPES} from "../../components/odds/components/odds-consts";

export const USER_COUNTRY_CONFIG = {
  '1': {
    defaultOddsType: ODDS_TYPES.fractional
  },
  '8': {
    defaultOddsType: ODDS_TYPES.fractional
  },
  '9': {
    defaultOddsType: ODDS_TYPES.fractional
  },
  '99': {
    defaultOddsType: ODDS_TYPES.fractional
  },
  '166': {
    defaultOddsType: ODDS_TYPES.fractional
  },
  '18': {
    defaultOddsType: ODDS_TYPES.american
  },
  '31': {
    defaultOddsType: ODDS_TYPES.american
  },
  '66': {
    defaultOddsType: ODDS_TYPES.american
  },
  '68': {
    hideLanguages: [2]
  },
  '81': {
    hideLanguages: [2]
  },
  '114': {
    hideLanguages: [2]
  },
  '115': {
    hideLanguages: [2]
  },
  '116': {
    hideLanguages: [2]
  },
  '117': {
    hideLanguages: [2]
  },
  '119': {
    hideLanguages: [2]
  },
  '122': {
    hideLanguages: [2]
  },
  '123': {
    hideLanguages: [2]
  },
  '124': {
    hideLanguages: [2]
  },
  '125': {
    hideLanguages: [2]
  },
  '126': {
    hideLanguages: [2]
  },
  '127': {
    hideLanguages: [2]
  },
  '130': {
    hideLanguages: [2]
  },
  '131': {
    hideLanguages: [2]
  },
  '135': {
    hideLanguages: [2]
  },
  '139': {
    hideLanguages: [2]
  },
  '161': {
    hideLanguages: [2]
  },
  '170': {
    hideLanguages: [2]
  },
  '185': {
    hideLanguages: [2]
  },
  '191': {
    hideLanguages: [2]
  },
  '226': {
    hideLanguages: [2]
  },
  '275': {
    hideLanguages: [2]
  },
  '284': {
    hideLanguages: [2]
  }
}
